import React from 'react'
import { useState } from 'react'
import {
  Box,
  TextField,
  MenuItem,
  InputLabel,
  Select,
  Grid,
  Switch,
  FormControlLabel,
  Typography, CircularProgress
} from '@mui/material'
import { StyledButton } from '../UI/StyledButton'
import Header from '../UI/Header'
import { useTheme } from '@mui/material/styles'
import OnlyWithFunction from '../OnlyWithFunctions'
import { useQuery } from '@tanstack/react-query'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { searchSintesiAccounting } from '../services/searchSintesiAccounting';
import ReportAccountingTable from '../Charts/ReportAccountingTable'
import dayjs from 'dayjs';
import 'dayjs/locale/it';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.locale('it');

const Accounting = (props) => {

  const theme = useTheme()
  const dataAperturaStyle = { display: 'flex', flexDirection: 'row', width: '100%' }
  const dataAperturaStyleOnlySintesi = { display: 'flex', flexDirection: 'row', width: '100%', marginBottom: "2%" }
  const tipoInserimento = ['Automatica Alto Rischio', 'Automatica Medio Rischio', 'Manuale'];
  const [fetchingData, setFetchingData] = useState(false)
  const [dataPraticaDa, setDataPraticaDa] = useState(null);
  const [dataPraticaA, setDataPraticaA] = useState(null);
  const [tipo, setTipo] = useState('');
  const [isTipoInserimentoEnabled, setIsTipoInserimentoEnabled] = useState(false);
  const [isDataPraticaEnabled, setIsDataPraticaEnabled] = useState(false);

  const {
    data: sintesiAccountingData,
    isFetched: sintesiAccountingIsFetched,
    refetch: sintesiAccountingRefetch
  } = useQuery({
    queryFn: () => searchSintesiAccounting(tipo, dataPraticaDa, dataPraticaA),
    queryKey: ["sintesiAccounting"],
    retry: false,
    refetchOnWindowFocus: false,
  })

  const formatToISOString = (date) => {
    return date?.toISOString() || '';
  };

  const handleDateChangePraticaDa = (date) => {
    const formattedDate = formatToISOString(date)
    setDataPraticaDa(formattedDate);
  };
  const handleDateChangePraticaA = (date) => {
    const formattedDate = formatToISOString(date)
    setDataPraticaA(formattedDate);
  };
  const handleToggleTipoInserimento = () => {
    setIsTipoInserimentoEnabled(!isTipoInserimentoEnabled);
    setTipo("");
  };

  const handleToggleDataPratica = () => {
    setIsDataPraticaEnabled(!isDataPraticaEnabled);
    setDataPraticaDa(null)
    setDataPraticaA(null)
  };

  const handleSelectChangeTipo = (event) => {

    setTipo(event.target.value);
  };


  const [reportAccounting, setReportAccounting] = useState(
    [{
      AutomaticaAltoRischio: 0,
      AutomaticaMedioRischio: 0,
      Manuale: 0
    }]
  );

  return (
    <div>
      <Header
        showHome={true}
        showRichiesta
        showStatistiche={false}
        header={
          <>
            <OnlyWithFunction
              acceptedFunction="UTENTE_INTERNO">
              <Grid spacing={5}>
                <Grid item xs={6}>
                  <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                    <div style={{ marginTop: '20px', marginRight: '15px' }}>
                      <div style={{ display: 'flex', flexdirection: 'row' }}>
                        <InputLabel sx={{ paddingBottom: 0, paddingRight: 0, }}>Tipo Inserimento</InputLabel>
                        <FormControlLabel
                          control={
                            <Switch checked={isTipoInserimentoEnabled} size="small" onChange={handleToggleTipoInserimento} />}
                          label={<Typography sx={{ color: theme.palette.black.main, size: 5 }} variant="caption">
                            {!isTipoInserimentoEnabled ? 'OFF' : 'ON'}</Typography>}
                        />
                      </div>
                      <Select
                        value={tipo}
                        onChange={handleSelectChangeTipo}
                        sx={{ width: '180px', height: '30px', marginTop: '15px' }}
                        disabled={!isTipoInserimentoEnabled}
                      >
                        {tipoInserimento.map((opzione, index) => (
                          <MenuItem key={index} value={opzione}>
                            {opzione}
                          </MenuItem>
                        ))}
                      </Select>
                    </div>
                    <div style={props.onlySintesi ? dataAperturaStyleOnlySintesi : dataAperturaStyle}>
                      <Grid>
                        <div style={{ display: 'flex', flexdirection: 'row' }}>

                          <InputLabel sx={{ paddingTop: '20px', paddingBottom: 1 }}>Data Apertura</InputLabel>
                          <FormControlLabel sx={{ marginTop: '20px' }}
                            control={
                              <Switch checked={isDataPraticaEnabled} size="small" onChange={handleToggleDataPratica} />}
                            label={<Typography sx={{ color: theme.palette.black.main }} variant="caption">
                              {!isDataPraticaEnabled ? 'OFF' : 'ON'}</Typography>}
                          />
                        </div>
                        <Grid container xs={12}>
                          <Grid item xs={11}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
                              <DatePicker
                                value={dataPraticaDa}
                                onChange={handleDateChangePraticaDa}
                                renderInput={(props) => (
                                  <TextField {...props} label="Da" sx={{
                                    width: '160px',
                                    paddingRight: 2,
                                    '& .MuiSvgIcon-root': {
                                      marginRight: '5px',

                                    },
                                  }} />
                                )}
                                format="DD/MM/YYYY" // Imposta il formato della data come "dd/mm/yyyy"
                                sx={{ width: '100%' }}
                                disabled={!isDataPraticaEnabled}
                              />
                            </LocalizationProvider>
                          </Grid>
                          <Grid item xs={11}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
                              <DatePicker
                                value={dataPraticaA}

                                onChange={handleDateChangePraticaA}
                                renderInput={(props) => (
                                  <TextField {...props} label="A" sx={{
                                    width: '160px',
                                    paddingRight: 2,
                                    '& .MuiSvgIcon-root': {
                                      marginRight: '5px',

                                    },
                                  }} />
                                )}
                                format="DD/MM/YYYY" // Imposta il formato della data come "dd/mm/yyyy"

                                sx={{ width: '100%' }}
                                disabled={!isDataPraticaEnabled}

                              />
                            </LocalizationProvider>
                          </Grid>
                        </Grid>
                      </Grid>
                    </div>
                    <Grid item xs={4}>
                      <div style={{ display: 'flex', flexdirection: 'row' }}>

                        <Box sx={{ m: 1, position: 'relative' }}>
                          <StyledButton
                            disabled={fetchingData}
                            onClick={e => { sintesiAccountingRefetch() }
                            }
                            sx={{
                              backgroundColor: theme.palette.grey.light,
                              color: theme.palette.black.main,
                              border: '0px',
                              paddingRight: '10px',
                              mr: 4,
                              mt: 2,
                            }}
                          >
                            <Typography variant="caption">CERCA</Typography>
                          </StyledButton>
                          {fetchingData && (
                            <CircularProgress
                              size={24}
                              sx={{

                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                marginTop: '-10px',
                                marginLeft: '-25px',
                              }}
                            />
                          )}
                        </Box>
                      </div>
                    </Grid>
                  </div>
                </Grid>
              </Grid>
            </OnlyWithFunction>
          </>
        }
      />
      <Box padding={8}>
        {sintesiAccountingIsFetched &&
          <ReportAccountingTable data={sintesiAccountingData} />
        }
      </Box>
    </div>
  );
}

export default Accounting;

